import { Component, Input } from '@angular/core';
import { IndicatorsItem } from '@interfaces';

@Component({
  selector: 'unicon-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss'],
})
export class IndicatorsComponent {
  @Input() item!: IndicatorsItem;
}
